export var thermometer = [
    {
        id:1,
        img:require("../../Images/Thermometer1.jpg"),
        title:"thermometer",
        description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price:"350 EGP"
    },
    {
        id:2,

        img:require("../../Images/Thermometer2.jpg"),
        title:"thermometer",
        description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price:"450 EGP"
    },
    {
        id:3,

        img:require("../../Images/Thermometer3.jpg"),
        title:"thermometer",
        description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price:"250 EGP"
    },
    {
        id:4,

        img:require("../../Images/Thermometer4.jpg"),
        title:"thermometer",
        description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price:"2500"
    },
    {
        id:5,

        img:require("../../Images/Thermometer5.jpg"),
        title:"thermometer",
        description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price:"1500"
    },
    {
        id:6,

        img:require("../../Images/thermometer6.jpg"),
        title:"thermometer",
        description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price:"1300"
    },
    {
        id:7,

        img:require("../../Images/thermometer7.jpg"),
        title:"thermometer",
        description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price:"900"
    },
    {
        id:8,

        img:require("../../Images/thermometer8.jpg"),
        title:"thermometer",
        description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price:"1200"
    },
    {
        id:9,

        img:require("../../Images/thermometer9.jpg"),
        title:"thermometer",
        description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price:"1250"
    },
    {
        id:10,

        img:require("../../Images/thermometer10.jpg"),
        title:"thermometer",
        description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price:"1400"
    },
    {
        id:11,

        img:require("../../Images/thermometer11.jpg"),
        title:"thermometer",
        description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price:"1350"
    },
    {
        id:12,

        img:require("../../Images/thermometer12.jpg"),
        title:"thermometer",
        description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price:"1550"
    },



]